import { render, staticRenderFns } from "./ActionRufnummernblockTsCfgEinpflegenHumanTask.vue?vue&type=template&id=17967eb5&scoped=true&"
import script from "./ActionRufnummernblockTsCfgEinpflegenHumanTask.vue?vue&type=script&lang=js&"
export * from "./ActionRufnummernblockTsCfgEinpflegenHumanTask.vue?vue&type=script&lang=js&"
import style0 from "./ActionRufnummernblockTsCfgEinpflegenHumanTask.vue?vue&type=style&index=0&id=17967eb5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17967eb5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})
